
















































































































































































































































































































import hash from 'object-hash';
import { listFactory } from '@/main/pages';
import { showAlert } from '@/main/utils/notifications';
import { convertToObjects, CellNamesObject, cellNames, intToRgb, Row, getColumnsRowMapObjectForExportFunc, columnsToCamelCase, ObjectType } from '@/main/utils/table';
import { apiProvider } from '@/modules/servis/rezervaceND/api';
import { apiProvider as apiProviderNd } from '@/modules/servis/zakazka/nahradniDily/api';
import { apiProvider as apiProviderParts } from '@/modules/sklad/ndSklad/api';
import { apiProvider as orderApiProvider } from '@/modules/servis/zakazka/api';
import { START_LOADING, END_LOADING } from '@/main/store/listEditTypes';
import _ from 'lodash';
import { openEdit, openList } from '@/main/router/routerPath';
import { PageMode } from '@/main/utils/pageMode';
import { EditableStatus, ScreenSize } from '@/main/components/constants';

import { DropdownItem } from '@/main/store/@types/dropdown.d';

import { TABLE_DATA_EXPORT } from '@/main/store/listEditTypes';

import { forceFileDownload, localizeFileName, parseObj2Csv, renameKeysForExportFunc } from '@/main/utils/fileHelper';

import { isUserPartsManager, OpenPartMaintenance } from '@/main/utils/commonFunctions';

import DmsEditableTable from '#components/dms/layout/EditableTable.vue';

import Save from '#components/dms/button/Save.vue';

import { ZAKAZKA_DRUH } from '../zakazka/constants';

import {
	NAME, ADDITIONAL_WORK_STATUS, ADDITIONAL_JOB_STATUS, PARTS_COLS, STOCK_STATUS, SPLIT_BILLING, PARTS, ORDER_STATUS,
	MIN_DISCOUNT_LIMIT, MAX_DISCOUNT_LIMIT, UOM, RESERVATION_PARTS_ROW_LENGTH , DefualtQuantity, CRUMB_LABEL_KEY,
	BULK_UPLOAD,
	ROW_SAVED,
	ROW_EDIT_CLICKED,
	BULK_PARTS_UPLOAD
} from './constants';

import { store } from './store/list';
import { number } from '@storybook/addon-knobs';

export default listFactory(NAME, store).extend({
	components: {
		DmsEditableTable,
		'dms-save': Save,
	},
	data() {
		return {
			showDateFilter: false,
			notificationDialog: {
				visible: false,
				notificationDialogMsg: this.LocalizePopisostatni('requisitionForm'),
				handleClose: () => {},
			},
			showDialog: {
				visible: false,
				title: null as string | null,
				extraButtons: null as object | null,
				handleClose: () => {},
			},
			fileList: [] as any[],
			ADDITIONAL_JOB_STATUS,
			partsCols: PARTS_COLS,
			orderId: null as number | null,
			eanInput: '',
			brand: '',
			quantityInput: '',
			partNumber: '',
			descriptionInput: '',
			expandedUnit: '',
			conversionQuantity: null as number | null,
			wearHouse: '',
			technicianId: null as number | null,
			serviceJobId: null as number | null,
			inputWareHouse: '',
			inputPartCategory: '',
			inputTechnicianId: null as number | null,
			inputServiceJobId: null as number | null,
			cancelWareHouse: '',
			canceltechnicianId: null as number | null,
			cancelServiceJobId: null as number | null,
			cancelPartCategory: '',
			inputBrand: '',
			cancelBrand: '',
			inputPartNumber: '',
			cancelPartNumber: '',
			inputDescription: '',
			cancelDescription: '',
			inputMrp: '',
			cancelMrp: '',
			inputRrpUnitPrice: '',
			cancelRrpUnitPrice: '',
			inputQuantity: '',
			cancelQuantity: '',
			inputUnit: '',
			cancelUnit: '',
			VydejMjId: null as number | null,
			screenSize: ScreenSize.TABLET,
			windowWidth: window.innerWidth,
			splitShareTableloading: true,
			splitShareTable: [],
			showSplitSharesPartsDialog: false,
			tableKey: '0',
			showDiscountSection: false,
			TotDiscPercentParts: 0 as number | null,
			isDiscountEditable: true,
			isDNPEditable: false,
			selectedPartNumber: '',
			timeout: null as any | null,
			selectedBrand: null as string | null,
			selectedPrice: [] as any[],
			selectedUnitText: null as string | null,
			selectedBaseUnitIndex: null as string | null,
			spDiscount: 0 as number | null,
			reserveQuantity: 0 as number | null,
			availableQuantity: 0 as number | null,
			cancelSpDiscount: 0 as number | null,
			cancelReserveQuantity: 0 as number | null,
			cancelAvailableQuantity: 0 as number | null,
			originalDiscountPercent: null as number | null,
			originalDiscountAmount: null as number | null,
			discountAmountReverted: false,
			isSaving: false,
			workshopIdForPartsUpload: null as number | null,
			warehouseIdForPartsUpload: null as number | null,
			_indexCache: null as any,
			partsListCache: new Map<string, any[]>(),
			partsMenuReady: false,
			mrpTextByValue: new Map<string, string>(),
			dnpTextByValue: new Map<string, string>(),
			debouncedWarrantyCheck: null as any,
			debouncedMrpFetch: null as any,
			allDnpLoading: false,
			allMrpLoading: false,
			partBlurTimeout: null as any,
			partChangeToken: 0 as number,
			lastPartChangeRow: null as Row | null,
			lastPartChangeVal: '' as string,
			lastPartChangeAt: 0 as number,
			partChangeInFlight: new Set<string>(),
		};
	},
	computed: {
		isUserPartsManager(): boolean {
			return isUserPartsManager(this.pracovnik.PracovnikOzn, this.userRoles);
		},
		isFromReservation(): boolean {
			return this.ZakazkaId === undefined || this.ZakazkaId === null || this.ZakazkaId <= 0;
		},
		selectionIsEmpty(): boolean {
			return _.isEmpty(this.multipleSelection);
		},
		notificationTitle() : string {
			return this.LocalizePopisostatni('Update');
		},
		isWorkshopOrder(): boolean {
			return this.props.IsWorkshopContractOrder;
		},
		SplitShareDetailsTitle() : string {
			return this.LocalizePopisostatni('SplitShareDetails');
		},
		discountDialogTitle() : string {
			return this.LocalizePopisostatni('ApplyDiscount');
		},
		selectedRowId() : any[] | null {
			return this.selectedNdRow ? this.selectedNdRow[0] : null;
		},
		tableListeners(): {} {
			return {
				sideBarSelectRow: this.sideBarSelectRow,
				'save-column-setting': this.saveColumnSetting,
				selectedRow: this.selectedRow,
				'update:multipleSelection': this.handleSelection,
			};
		},
		tableModel():{} {
			return {
				table: this.table,
				sideBarLoading: this.sideBarLoading,
				'multiple-selection': this.multipleSelection,
				'select-row': this.selectedRowId,
			};
		},
		cellNamesCmp(): CellNamesObject {
			return cellNames(this.table);
		},
		isModified(): boolean {
			return this.table.hash !== hash(this.table.rows);
		},
		getWidth() :string {
			return this.windowWidth <= this.screenSize ? ScreenSize.DIALOG_TABLET_WIDTH : ScreenSize.DIALOG_DEFAULT_WIDTH;
		},
			optimizePerf(): boolean {
			return !this.isFromReservation;
		},
	},
	created() {
		this.debouncedWarrantyCheck = _.debounce(
			this.isWarrantyOrGoodwillSplitExists.bind(this),
			300
		);

		this.debouncedMrpFetch = _.debounce(
			this.getMrpDetails.bind(this),
			300
		);
	},

	async mounted() {
		// Hard page refresh issue handle
		const isIdExist = 'ZakazkaId' in this.props.filter;
		if (this.$route.query.ZakazkaId) {
			const filter = {
				ZakazkaId: +this.$route.query.ZakazkaId,
				OrderStatus: +this.$route.query.OrderStatus,
				DefaultWarehouseId: this.$route.query.DefaultWarehouseId,
				WorkShopId: this.$route.query.WorkShopId,
				OrderNo: this.$route.query.OrderNo,
				ZakazkaNr: this.$route.query.OrderNo,
				ZakaznikId: this.$route.query.ZakaznikId,
				ZakazkaDruh: this.$route.query.ZakazkaDruh
			} as any;
			this.ZakazkaId = filter.ZakazkaId;
			this.filter = { ...filter };
			this.props.filter = filter;
			const { data } = await apiProvider.GetTechnicianListByWorkshopId(filter.WorkShopId);
			this.dropdownList.TechiciansList = data;
			if (this.ZakazkaId !== null) {
			 const { data } = await apiProvider.GetServiceJobByZakazkaId(this.ZakazkaId ?? 0);
			 this.dropdownList.ServiceJobsList = data;
			}
		}
		if (this.loggedUser.DmsSys.DateFilterPrp) {
			this.showDateFilter = true;
		}
		//Getting MRP and DNP of all Parts 
		const {data} =  await apiProvider.GetCombinedMrpDnp();
		this.dropdownList.CombinedMrpDnp = data;
		this.dropdownList.AllMrp = this.dropdownList.CombinedMrpDnp.map(item => ({
			Text: item.Text.split('-')[0].trim(),
			Value: item.Value
		}));
		this.dropdownList.AllDnp = this.dropdownList.CombinedMrpDnp.map(item => ({
			Text: item.Text.split('-')[1]?.trim(),
			Value: item.Value
		}));
		// O(1) lookups for cell rendering — no per-row .find(), no API calls from render
		this.mrpTextByValue = new Map(this.dropdownList.AllMrp.map((item: any) => [String(item.Value), item.Text]));
		this.dnpTextByValue = new Map(this.dropdownList.AllDnp.map((item: any) => [String(item.Value), item.Text]));
	},
	methods: {
		onPartNumberClick(row: Row) {
			OpenPartMaintenance({ cellNames: this.table.cellNames, row });
		},
		async exportFun() {
			const tableData = [] as any;
			const exportDataTable = _.cloneDeep(this.table);
			exportDataTable.rows.forEach((row: any) => {
				const brandIndex: number = this.table.cellNames?.X_VYROBEKND_OZN!;
				const orderResult: DropdownItem = this.dropdownList.VyrobekndOzn.find((item: any) => item.Value === row.cells[brandIndex])!;
				row.cells[brandIndex] = orderResult?.Text ?? row.cells[brandIndex];

				const priceIndex: number = this.table.cellNames?.PART_MRP!;
				row.cells[priceIndex] = this.getMrp(row, priceIndex);

                const ServiceJobIndexs = this.table.cellNames?.SERVICE_JOB_ID!;
				row.cells[ServiceJobIndexs] = this.getServiceJobNameDetails(row, ServiceJobIndexs);
				
				const warehouseIndex: number = this.table.cellNames?.X_SKLAD_OZN!;
				row.cells[warehouseIndex] = this.getWorkshopDetails(row, warehouseIndex);

				const rowData = getColumnsRowMapObjectForExportFunc(columnsToCamelCase(exportDataTable.columns.filter(x => x.isVisible === true)), row.cells, ObjectType.columnName, true);
				tableData.push(rowData);
			});
			const formattedObj = tableData.map((row: any) => renameKeysForExportFunc(row));
			const val = localizeFileName(CRUMB_LABEL_KEY);
			const url = `data:text/csv;charset=utf-8,%EF%BB%BF${encodeURIComponent(parseObj2Csv(formattedObj))}`;
			return forceFileDownload(url, val);
		},
		async onRrpUnitPriceChange(value: any, row: Row, columnId: number, updateCol: any) {
			updateCol(value, columnId);
			row.cells[columnId] = value;
		},
		async updatePrice(value: any, row: Row, columnId: number, updateCol: any) {
			updateCol(value, columnId);
			row.cells[columnId] = value;
			this.inputMrp = value;
		},
		async onRrpUnitPriceLeave(value: any, row: Row, columnId: number, updateCol: any) {
			if (value <= 0 || value === null) {
				this.showErrorAlert({
					message: this.LocalizeChyboveHlasky('msgCorrectUnitPrice'),
					options: { type: 'error' },
					localizeMessage: false,
				});
				row.cells[columnId] = this.inputRrpUnitPrice;
				return false;
			}
			updateCol(value, columnId);
			this.inputRrpUnitPrice = value;
			row.cells[columnId] = value;
		},
		async onRowDiscountChange(value: string, columnId: number, updateCol: any, row: Row) {
			const normalizedValue = value === null || value === undefined || value === '' ? 0 : value;
			if (this.dmsSys.OrderDiscountPrp !== true) {
				updateCol(normalizedValue, columnId);
				row.cells[columnId] = normalizedValue;
				return true;
			}
			if (this.validateRowLevelDiscount(normalizedValue, updateCol, row) === false) {
				return false;
			}
			row.cells[columnId] = +(_.defaultTo(normalizedValue, 0));
			return true;
		},
		async onCheckClick(event: any) {
			clearTimeout(this.timeout);
			this.timeout = setTimeout(() => {
				if (event.target.value.length > 2) {
					this.dropdownList.Parts = this.dropdownList.DefaultPartsList.filter((item: any) => item.Text.includes(event.target.value.toUpperCase()));
				}
			}, 800);
		},
		async partEntered(newValue: any) {
			this.dropdownList.Parts = [];
			this.dropdownList.Parts = this.dropdownList.DefaultPartsList.filter((item: any) => item.Text.includes(newValue.toUpperCase()));
		},
		handleSelection(rows: Row[]) {
			this.multipleSelection = rows;
		},
		async createRow() {
			if(!this.canAddPart()) {
				showAlert({
						message: this.LocalizeChyboveHlasky('CANNOT_ADD_NEW_ITEM'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'info',
						},
					});
					return;
			}
			if (this.table.rows.length >= RESERVATION_PARTS_ROW_LENGTH) {
				const technicianIndex: number = this.table.cellNames!.TECHNICIAN;
				this.technicianId = this.table.rows[0].cells[technicianIndex];
			}
			this.selectedPartNumber = '';
			this.isDiscountEditable = true;
			this.isDNPEditable = false;
			this.dropdownList.Parts = [];
			this.partsMenuReady = true; // prime dropdown DOM once per page session
			(this.$refs.editableTable as any).createRow();
		},
		async handleClose() {
			if (this.table.isModified()) {
				if (await this.getConfirmationForModifiedTable()) {
					this.closeClick();
				}
			} else {
				this.closeClick();
			}
		},
		getLocalizedText(text: string) {
			return this.LocalizePopisPoli(text);
		},
		onTextInput(event: any, row: Row, columnId: number) {
			this.descriptionInput = event;
			row.cells[columnId] = event;
		},
		isSplitBillingAvailableForOrderType(row: Row): boolean {
			return ((row.cells[this.table.cellNames!.ORDER_TYPE] === ZAKAZKA_DRUH.PRODEJ_ZBOZI
					|| row.cells[this.table.cellNames!.ORDER_TYPE] === ZAKAZKA_DRUH.DILENSKA)
					&& row.cells[this.table.cellNames!.VEHICLE_ID] !== null);
		},
		isPartyLevelDiscountEnabled(row: Row, columnId: number): boolean {
			const currentRowId = row.cells[this.table?.cellNames!.ZAZNAM_ID];
			if(!(currentRowId > 0)) {
				return false;
			}
			const isPartyLevelDiscEnabledColId = this.table?.cellNames?.IS_PARTY_LEVEL_DISCOUNT_ENABLE;
			const discountColId = this.table?.cellNames?.DISCOUNT_PERCENT ?? columnId;

			// Guard first: do not index with undefined/null
			if (isPartyLevelDiscEnabledColId == null || discountColId == null) {
				return false;
			}

			const discountValue = row.cells[discountColId];
			const isPartyLevelDiscEnabled = row.cells[isPartyLevelDiscEnabledColId];
			const partyLevelDiscountEnabled = isPartyLevelDiscEnabled === true
				|| isPartyLevelDiscEnabled === 1
				|| String(isPartyLevelDiscEnabled).toLowerCase() === 'true'
				|| String(isPartyLevelDiscEnabled) === '1';

			const hasNonZeroDiscount = discountValue !== null
				&& discountValue !== undefined
				&& discountValue !== ''
				&& !Number.isNaN(+discountValue);

			if (hasNonZeroDiscount) return false;
			if (!partyLevelDiscountEnabled) return false;

			return true;
		},
		// getDiscountPercent(row: Row, columnId: number): number {
		// 	const value = row.cells[columnId];
		// 	return value === null || value === undefined || value === '' ? 0 : +value;
		// },
		redirectToSplitBilling(row: Row): boolean {
			return (row.cells[this.table.cellNames!.ORDER_STATUS] !== ORDER_STATUS.CLOSED);
		},
		onSplitSharesPartsDialogClosed() {
			this.splitShareTableloading = false;
		},
		async submitUpload() {
			const StartTime = performance.now();
			if (this.fileList.length === 0) {
				this.showErrorAlert({
					message: this.LocalizeChyboveHlasky('UploadFile'),
					options: { type: 'error' },
					localizeMessage: false,
				});
				return;
			}
			if (!this.workshopIdForPartsUpload) {
				this.showErrorAlert({
					message: this.LocalizeChyboveHlasky('WorkShopNotBeNull'),
					options: { type: 'error' },
					localizeMessage: false,
				});
				return;
			}
			if (!this.warehouseIdForPartsUpload) {
				this.showErrorAlert({
					message: this.LocalizeChyboveHlasky('WareHouseNotBeNull'),
					options: { type: 'error' },
					localizeMessage: false,
				});
				return;
			}
			this.startLoading();
			const { data: partsInfo } = await apiProvider.uploadParts(this.fileList[0], this.ZakazkaId, this.filter.ZakazkaNr, this.ZakaznikId, this.ZakazkaDruh, this.warehouseIdForPartsUpload);
			this.fileList = [];
			this.workshopIdForPartsUpload = null;
			this.warehouseIdForPartsUpload = null;
			if (partsInfo) {
				showAlert({
					message: partsInfo,
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: { type: 'info' },
				});
			}
			this.showDialog.visible = false;
			await this.tableData();
			let iTotalTimeTaken = performance.now() - StartTime;
            let seconds = parseFloat((iTotalTimeTaken / 1000).toFixed(2));
			await apiProvider.logPerformance('OrderPrp', 'Reservation', BULK_PARTS_UPLOAD, seconds);
			this.endLoading();
		},
		async onApplyDiscountClick() {
			if (this.table.rows.length > 0) {
				const { data: sectionDiscount } = await apiProvider.getSectionPartDiscount(this.ZakazkaId!);
				this.TotDiscPercentParts =	sectionDiscount;
				this.showDiscountSection = true;
			} else {
				this.showErrorAlert({
					message: this.LocalizeChyboveHlasky('NoPartsAdded'),
					options: { type: 'error' },
					localizeMessage: false,
				});
			}
		},
		async saveDiscount() {
			if (this.TotDiscPercentParts! > MAX_DISCOUNT_LIMIT || this.TotDiscPercentParts! < MIN_DISCOUNT_LIMIT) {
				this.TotDiscPercentParts = 0;
				this.showErrorAlert({
					message: this.LocalizeChyboveHlasky('msgNotMoreDiscThn100Per'),
					options: { type: 'error' },
					localizeMessage: false,
				});
				return;
			}
			const isDiscountApplicable = await this.checkForDiscountLimit(false, 0);
			if (isDiscountApplicable) {
				this.updateDiscount();
			}
		},
		async updateDiscount() {
			this.showDiscountSection = false;
			this.startLoading();
			await orderApiProvider.updatePartDiscount(this.ZakazkaId!, this.TotDiscPercentParts, 0);
			this.endLoading();
		},
		checkForDiscountLimit(Level: boolean, Sleva: any) {
			if (this.dmsSys.OrderDiscountPrp !== true) return true;
			let errormsg = null;
			if (this.loggedUser.DiscountLimitConfigData === null) errormsg = this.LocalizeChyboveHlasky('msgNotPerToAplyDisc');
			else {
				errormsg = this.validateDiscount(
					this.loggedUser.DiscountLimitConfigData.PartItemTotalPer,
					Level,
					Sleva,
				);
				if (Level) {
					errormsg = this.validateDiscount(
						this.loggedUser.DiscountLimitConfigData.PartItemPer,
						Level,
						Sleva,
					);
				}
			}
			if (errormsg !== null) {
				this.TotDiscPercentParts = 0;
				this.showErrorAlert({
					message: `${errormsg}${this.LocalizeAndReplace(this.LocalizePopisostatni(Level
						? 'PART_ITEM' : 'PART_ITEM_TOTAL'), { key: this.LocalizePopisostatni('Level_Limit'), value: '' }).toLowerCase()}.`,
					options: { type: 'error' },
					localizeMessage: false,
				});
				return false;
			}
			return true;
		},
		validateDiscount(discountper: number, Level: boolean, sleva: any) {
			let errormsg = null;
			if (discountper === 0) {
				errormsg = this.LocalizeChyboveHlasky('msgNotPerToAplyDisc');
				return errormsg;
			} if (discountper > 0 && discountper < (this.TotDiscPercentParts === null ? 0 : this.TotDiscPercentParts)) {
				errormsg = this.LocalizeChyboveHlasky('msgNotAplyMoreThnDiscPer').replace('<DISC_PER>', `${discountper}%`);
				return errormsg;
			}
			return errormsg;
		},

		cellClick(row: any, column: any, cell: any) {
			const rezPartNumberColId: number = this.table.cellNames!.ZAZNAM_ID;
			const spDiscountColId: number = this.table.cellNames!.SP_DISCOUNTED;
			const orderColId: number = this.table.cellNames!.ZAKAZKA_NR!;
			const orderId = row.cells[orderColId]!;
			const quantityColId = this.table.cellNames!.X_REZERVVLASTNI;
			const partColId = this.table.cellNames!.ND_NR;
			const discountId = this.table.cellNames!.DISCOUNT_PERCENT;

			if (this.isSplitBillingAvailableForOrderType(row)) {
				if (this.redirectToSplitBilling(row) && column === spDiscountColId) {
					const itemId = row.cells[rezPartNumberColId];
					const discountPercent = row.cells[discountId] ?? 0;
					openList(SPLIT_BILLING, {
						filter: {
							ItemType: PARTS,
							ServiceOrderId: orderId,
							ItemId: itemId,
							OrderStatus: this.filter.OrderStatus,
							PartNumber: row.cells[partColId],
							Quantity: row.cells[quantityColId],
							Modified: discountPercent,
						},
					}, { ServiceOrderId: orderId, ItemId: itemId, ItemType: PARTS, OrderStatus: this.filter.OrderStatus, PartNumber: row.cells[partColId], Quantity: row.cells[quantityColId], Modified: discountPercent });
				} else if (column === this.table.cellNames!.BILL_TO) {
					const itemId = row.cells[rezPartNumberColId];
					this.splitShareTable = [];
					this.getSplitShareDetails(itemId, orderId);
					this.showSplitSharesPartsDialog = true;
				}
			}
		},
		async getSplitShareDetails(itemId: number | null, orderId: number | null) {
			this.splitShareTableloading = true;
			const response = await apiProvider.getSplitDetails(itemId, orderId);
			this.splitShareTableloading = false;
			this.splitShareTable = response?.data;
		},
		handleChange(file: Record<string, any>) {
			this.fileList = [file];
		},
		handleRemove(file: File, fileList: []) {
			this.fileList = fileList;
		},
		showUploadPartsClick() {
			if(!this.canAddPart()) {
				showAlert({
						message: this.LocalizeChyboveHlasky('CANNOT_ADD_NEW_ITEM'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'info',
						},
					});
					return;
			}

			this.showDialog.visible = true;
		},
		async sendStatus(status: ADDITIONAL_JOB_STATUS) {
			const finalMessage = this.validateAdditionalWork();
			if (finalMessage !== '') {
				showAlert({
					message: finalMessage,
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
				return;
			}
			try {
				this.startLoading();
				await this.sendApprovalNotification(status);
				await this.setAdditionalStatus(status);
				await this.tableData();
			} catch (error) {
				this.logError(error as Error);
			} finally {
				this.endLoading();
			}
		},
		async sendApprovalNotification(status: ADDITIONAL_JOB_STATUS) {
			const idColumnIndex = this.table!.cellNames!.idColumn;
			const zakazkaIdColumnIndex = this.table!.cellNames!.ZAKAZKA_ID;
			const zakazkaIdVal = this.multipleSelection.map(row => [row.cells[idColumnIndex], row.cells[zakazkaIdColumnIndex]]);
			const promise = zakazkaIdVal.map((value: any[]) => apiProviderNd.sendEmailAndSmsApprovalNotification(value[1], status));
			return Promise.all(promise);
		},
		async setAdditionalStatus(status: ADDITIONAL_JOB_STATUS) {
			const idColumnIndex = this.table!.cellNames!.idColumn;
			const checkboxColumnIndex = this.table!.cellNames!.ZAZNAM_ID;
			const selectedValues = this.multipleSelection.map(row => [row.cells[idColumnIndex], row.cells[checkboxColumnIndex]]);
			const promises = selectedValues.map((value: any[]) => apiProvider.setAdditionalStatusForZakazkaNdrez(value[1], status));
			return Promise.all(promises);
		},
		validateAdditionalWork(): string {
			let finalMessage = '';
			const COLUMN_INDEX = true;
			const idAdditionalJobColumnIndex = this.table!.cellNames!.IS_ADDITIONAL;
			const idAdditionalStatusColumnIndex = this.table!.cellNames!.ADDITIONAL_JOB_STATUS;
			const idNdNrColumnIndex = this.table!.cellNames!.ND_NR;
			const alreadyActionedParts = this.multipleSelection.reduce((record: string, sum: Row) => {
				const validData = sum.cells !== null && !_.isEmpty(sum.cells[idAdditionalStatusColumnIndex])
                    && !sum.cells[idAdditionalStatusColumnIndex].includes(ADDITIONAL_WORK_STATUS.CUSTOMER_APPROVAL_PENDING);
				return validData ? record + sum.cells[idNdNrColumnIndex] : record;
			}, '');
			const notAdditionalParts = this.multipleSelection.reduce((record: string, sum: Row) => {
				const validData = sum.cells !== null && sum.cells[idAdditionalJobColumnIndex] !== null
                && sum.cells[idAdditionalJobColumnIndex] !== COLUMN_INDEX;
				return validData ? record + sum.cells[idNdNrColumnIndex] : record;
			}, '');
			if (alreadyActionedParts !== '') {
				finalMessage = this.LocalizeAndReplace(this.LocalizeChyboveHlasky('PartsActioned'), { key: '#ActionedParts#', value: alreadyActionedParts });
				this.multipleSelection = [];
			}
			if (notAdditionalParts !== '') {
				finalMessage = `${finalMessage}\n \n ${this.LocalizeAndReplace(this.LocalizeChyboveHlasky('PartsNotAdditional'),
					{ key: '#NotAdditionalPart#', value: notAdditionalParts })}`;
				this.multipleSelection = [];
			}
			return finalMessage;
		},
		tableCellStyle({ row, column }:{ row: Row, column: any }) {
			if (column.label === this.LocalizePopisPoli('PART_RESERVE_STATUS')) {
				const rgb = intToRgb(row.cells[this.cellNamesCmp.PARTROWCOLOR]);
				return rgb ? { background: rgb, color: 'transparent' } : { color: 'transparent' };
			}
			return null;
		},
		editClick(event: any) {
			if (event.data.SERVICE_PACKAGE_ID !== null && event.data.SERVICE_PACKAGE_ID > 0) {
				showAlert({
					message: this.LocalizeChyboveHlasky('ItemCannotEidt'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
				return;
			}
			openEdit(NAME, PageMode.EDIT, { id: event.data.ZAZNAM_ID });
		},
		updateRow(rowUpdateData: { tableName: string; updateStatus: EditableStatus; rowId: number; row: Row }) {
			this.$store.commit(`${this.storeUri}/updateTableRow`, rowUpdateData);
		},
			onPartInputBlur(row: Row, columnId: number) {
			clearTimeout(this.partBlurTimeout);
			// Order screen only: nothing to look up for an empty part (e.g. blur from a row being replaced by "+"/another edit).
			if (this.optimizePerf && !this.selectedPartNumber) {
				return;
			}
			this.partBlurTimeout = setTimeout(() => {
				this.handleOnPartChange(this.selectedPartNumber, row, columnId);
			}, 200);
		},
		onPartItemClick(value: string, row: Row, columnId: number) {
			clearTimeout(this.partBlurTimeout);
			this.handleOnPartChange(value, row, columnId);
		},
		async handleOnPartChange(val: string, row: Row, columnId: number) {
			// Order screen only: a second blur/click firing with the same value for the same cell shortly after is a duplicate — ignore it.
			if (this.optimizePerf) {
				const now = Date.now();
				if (this.lastPartChangeRow === row && this.lastPartChangeVal === val && (now - this.lastPartChangeAt) < 1500) {
					return;
				}
				this.lastPartChangeRow = row;
				this.lastPartChangeVal = val;
				this.lastPartChangeAt = now;
			}
			// Order screen only: blocks a concurrent in-flight call for the same row+column+value (time-window check above doesn't stop overlapping async calls).
			const idColumnIndex = this.table!.cellNames!.idColumn;
			const inFlightKey = `${row.cells[idColumnIndex]}|${columnId}|${val}`;
			if (this.optimizePerf) {
				if (this.partChangeInFlight.has(inFlightKey)) {
					return;
				}
				this.partChangeInFlight.add(inFlightKey);
			}
			try {
			// Order screen only: a newer call for this cell supersedes this one — the stale call bails out at the next checkpoint below.
			const partChangeToken = this.optimizePerf ? ++this.partChangeToken : 0;
			const stockIndex: number = this.table.cellNames?.X_SKLAD_OZN!;
			let wearHouse = row.cells[stockIndex];
			if (!wearHouse) {
				wearHouse = this.wearHouse;
			}
			const partIndex: number = this.table.cellNames?.ND_NR!;
			const part = row.cells[partIndex] = val;
			this.selectedPartNumber = val;
			this.startLoading();
			const orderColId: number = this.table.cellNames!.ZAKAZKA_NR!;
			const orderId: any = this.getOrderDetails(row, orderColId);
			if (this.isDNPVisible()) {
				this.isDNPEditable = true;
			}

			const availableQuantityIndex: number = this.table.cellNames?.AVAILABLE_QUANITY!;
			const reserveQuantityIndex: number = this.table.cellNames?.X_REZERVNAZAK!;
			const spDiscountIndex: number = this.table.cellNames?.SP_DISCOUNTED!;
			const partDescriptionIndex:number = this.table.cellNames?.TEXT!;
			const partQuantityIndex:number = this.table.cellNames?.X_REZERVVLASTNI!;
			const partDiscountIndex:number = this.table.cellNames?.DISCOUNT_PERCENT!;
			const rrpUnitPriceIndex:number = this.table.cellNames?.RRP_UNIT_PRICE!;
			const mrpIndex:number = this.table.cellNames?.PART_MRP!;
			row.cells[partDescriptionIndex] = '';
			row.cells[rrpUnitPriceIndex] = 0;
         	row.cells[mrpIndex] = 0;
			row.cells[availableQuantityIndex] = 0;
			this.availableQuantity = 0;
			row.cells[reserveQuantityIndex] = 0;
			this.reserveQuantity = 0;
			row.cells[spDiscountIndex] = 0;
			this.spDiscount = 0;
			row.cells[partDiscountIndex] = row.cells[partDiscountIndex] ?? 0;
			this.dropdownList.Mrp = [];
			const brandIndex: number = this.table.cellNames?.VYROBEKND_OZN!;
			let brand = row.cells[brandIndex];
			if (!brand) {
				brand = this.brand;
			}
			// Order screen only: an empty part has nothing to price/validate — skip the GetMrp/GetRrpUnitPrice/GetIsObsoletePartStock calls entirely.
			if (this.optimizePerf && !part) {
				this.endLoading();
				return;
			}
			if (this.optimizePerf && partChangeToken !== this.partChangeToken) {
				this.endLoading();
				return;
			}
			if (orderId !== null && orderId !== '' && orderId !== undefined && wearHouse !== '' && wearHouse !== null && wearHouse !== undefined) {
				const { data } = await apiProvider.getPricingDate(val, this.brand, orderId!, wearHouse);
				this.dropdownList.Mrp = data;
				this.selectedPrice = data;
				const mrpIndex: number = this.table.cellNames!.PART_MRP;
				row.cells[mrpIndex] = 0;
				if (data.length > 0) {
					row.cells[mrpIndex] = data[0].Value;
					this.inputMrp = data[0].Value;
				} else {
					this.inputMrp = '';
				}
			}
			let ProceedWithExpiredPart = true;
			let result: any;
			if (wearHouse !== '') {
				if (this.optimizePerf && partChangeToken !== this.partChangeToken) {
					this.endLoading();
					return;
				}
				if (part) {
					this.VydejMjId = null;
					result = await apiProvider.getPartsPrice(val, orderId, wearHouse);

					const brandInd: number = this.table.cellNames?.X_VYROBEKND_OZN!;
					row.cells[stockIndex] = result.data.SkladOzn;
					row.cells[brandInd] = result.data.VyrobekndOzn;
					const textIndex: any = this.table.cellNames?.TEXT!;
					this.descriptionInput = result.data?.Text;
					row.cells[textIndex] = result.data?.Text;
					this.VydejMjId = result.data?.VydejMjId;
					this.brand = result.data?.VyrobekndOzn;
					row.cells[brandIndex] = this.brand;
					this.expandedUnit = result.data?.ExpandedUnit;
					row.cells[availableQuantityIndex] = result.data?.Stav;
					this.availableQuantity = result.data?.Stav;

					if (result?.data?.IsExpiryAvailable) {
						ProceedWithExpiredPart = await this.showConfirm({
							message: this.LocalizeChyboveHlasky('PartsExpiryAlert'),
							title: this.LocalizeChyboveHlasky('questionTitle'),
							options: {
								confirmButtonText: this.Localize('Ano'),
								cancelButtonText: this.Localize('Ne'),
							},
						});
					}
				}
				if (this.optimizePerf && partChangeToken !== this.partChangeToken) {
					this.endLoading();
					return;
				}
				const { data: mrpPrice  } = await apiProvider.getUnitMRPPrice(val, this.brand, wearHouse);
				if (mrpPrice >= 0) {
					this.inputRrpUnitPrice = mrpPrice;
					row.cells[rrpUnitPriceIndex] = mrpPrice;
				}
				if (ProceedWithExpiredPart) {
					const partDescIndex: number = this.table.cellNames?.Text!;
					row.cells[partDescIndex] = part;

					const wearHouseIndex: number = this.table.cellNames?.X_SKLAD_OZN!;
					let wearHouse = row.cells[wearHouseIndex];
					if (!wearHouse) {
						wearHouse = this.wearHouse;
					}

					if (this.dmsSys.ServicPartVisulizationPrp) {
						const StockStatusDetails = result?.data?.StockStatus;
						if (StockStatusDetails === STOCK_STATUS.OUT_OF_STOCK) {
							this.endLoading();
							this.showErrorAlert({ message: 'OutOfStockMassage' });
							row.cells[partIndex] = '';
							return;
						}
						if (StockStatusDetails === STOCK_STATUS.STOCK_SHORTAGE) {
							this.endLoading();
							this.showErrorAlert({ message: 'StockShortage' });
						}
					}

					const unit = result?.data?.UnitOfMeasure;
					if (unit) {
						const unitText = (this.dropdownList.VydejMjId.find((item: any) => item.Value === this.VydejMjId!) as any)?.Text ?? '';
						const unitIndex: number = this.table.cellNames?.CONVERTED_UNIT_OF_MEASUREMENT!;
						row.cells[unitIndex] = unitText;
						this.selectedUnitText = unitText;
						const baseUnitIndex: number = this.table.cellNames?.BASE_UNIT_OF_MEASUREMENT!;
						row.cells[baseUnitIndex] = `${unit} (${'1'} ${unit} ${'='} ${this.expandedUnit} ${unitText})`;
						this.selectedBaseUnitIndex = row.cells[baseUnitIndex];
					}

					let orderId = this.ZakazkaId!;
					if (!orderId!) {
						const orderIdIndex: number = this.table.cellNames?.ZAKAZKA_NR!;
						orderId = row.cells[orderIdIndex]!;
					}
					if (!_.isNil(part) && !_.isNil(wearHouse) && !_.isNil(row.cells[partQuantityIndex]) && wearHouse !== '') {
						if (row.cells[partQuantityIndex] === '') {
							row.cells[partQuantityIndex] = DefualtQuantity;
						}
						if (this.optimizePerf && partChangeToken !== this.partChangeToken) {
							this.endLoading();
							return;
						}
						const { data: isObsoletePartStock } = await apiProvider.getisObsoletePartStock(part, wearHouse, this.brand, row.cells[partQuantityIndex]);
						this.showObsoleteErrorMsg(isObsoletePartStock, row, partIndex);
					}
				} else {
					row.cells[partIndex] = '';
				}
			}
			this.endLoading();
			} finally {
				if (this.optimizePerf) {
					this.partChangeInFlight.delete(inFlightKey);
				}
			}
		},
		async getMrpDetails(partNumber: string, brand: string, orderId: number, warehouseId: number) {
			if (orderId !== null && orderId !== undefined && warehouseId !== null && warehouseId !== undefined) {
				const { data } = await apiProvider.getPricingDate(partNumber, brand, orderId, warehouseId);
				this.dropdownList.Mrp = data;
			}
		},
		updateRows({ rows }: { rows: Row[] }) {
			this.table.rows = rows;
		},
		async rowSaved({ row: newRow }: { row: Row }) {
			try {
				const startTime = performance.now();
				this.startLoading();
				let { brand } = this;
				let { partNumber } = this;
				const discountIndex: any = this.table.cellNames?.DISCOUNT_PERCENT;
				const discountAmountColId = this.table.cellNames!.DISCOUNT_VAL;
				const itemIdColId = this.table.cellNames!.ZAZNAM_ID;
				const orderIdColId = this.table.cellNames!.ZAKAZKA_ID;
				if (newRow.cells[discountIndex] > MAX_DISCOUNT_LIMIT || newRow.cells[discountIndex] < MIN_DISCOUNT_LIMIT) {
					newRow.cells[discountIndex] = 0;
					this.showErrorAlert({
						message: this.LocalizeChyboveHlasky('msgNotMoreDiscThn100Per'),
						options: { type: 'error' },
						localizeMessage: false,
					});
					return false;
				}
				const serviceJobColIndex: number = this.table.cellNames?.SERVICE_JOB_ID!;
				const savedServiceJobId = newRow.cells[serviceJobColIndex];
				if (savedServiceJobId > 0 && await this.isWarrantyOrGoodwillExistInServiceJobSplit(savedServiceJobId)) {
					showAlert({
						message: this.LocalizeChyboveHlasky('Zero_Discount_Warning_Msg'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'info',
						},
					});
					newRow.cells[discountIndex] = 0;				
				}
				const wearHouseIndex: number = this.table.cellNames?.X_SKLAD_OZN!;
				let wearHouse = newRow.cells[wearHouseIndex];
				if (wearHouse === null || wearHouse === undefined || wearHouse == '') {
					showAlert({
						message: this.LocalizeChyboveHlasky('PLEASE_ENTER_REQUIRED_VALUES_FOR_PARTS'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'info',
						},
					});
					return false;
				}
				if (!wearHouse) {
					wearHouse = this.wearHouse;
				}
				this.TotDiscPercentParts = newRow.cells[discountIndex];
				if (this.checkForDiscountLimit(true, newRow.cells[discountIndex]) !== true) {
					newRow.cells[discountIndex] = 0;
					return false;
				}
				const itemId: number = +(newRow.cells[itemIdColId] ?? 0);
				if (itemId > 0) {
					const rrpUnitPriceColId: number = this.table.cellNames?.RRP_UNIT_PRICE!;
					const quantityColId: number = this.table.cellNames?.X_REZERVVLASTNI!;
					const validationResponse = await orderApiProvider.validateGrossDiscountAmountForSplitParties(
						newRow.cells[orderIdColId],
						itemId,
						'PARTS',
						newRow.cells[discountAmountColId] ?? 0,
						this.loggedUser.DiscountLimitConfigData?.PartItemPer ?? null,
						newRow.cells[rrpUnitPriceColId] ?? null,
						newRow.cells[quantityColId] ?? null,
					);
					const validationMessage: string = validationResponse?.data;
					if (validationMessage) {
						this.showErrorAlert({
							message: this.LocalizeChyboveHlasky(validationMessage),
							options: { type: 'error' },
							localizeMessage: false,
						});
						// Revert to the original value only on the first validation failure, keep user input on subsequent failures
						if (!this.discountAmountReverted) {
							newRow.cells[discountAmountColId] = this.originalDiscountAmount;
							newRow.cells[discountIndex] = this.originalDiscountPercent;
							this.discountAmountReverted = true;
						}
							this.$nextTick(() => {
							const editableTable: any = this.$refs.editableTable;
							const rowIndex = editableTable.editTableRows.indexOf(newRow);
							if (rowIndex >= 0) {
								editableTable.editRow(rowIndex, newRow);
							}
						});
						return false;
					}
				}
				const partCategoryIndex: number = this.table.cellNames?.X_VYROBEKND_OZN!;
				if (this.brand !== '' && (this.brand || this.brand !== newRow.cells[partCategoryIndex])) {
					const brandIndex: number = this.table.cellNames?.VYROBEKND_OZN!;
					newRow.cells[partCategoryIndex] = this.brand;
					brand = newRow.cells[partCategoryIndex];
				}

				const partIndex: number = this.table.cellNames?.ND_NR!;
				newRow.cells[partIndex] = (this.selectedPartNumber !== null && this.selectedPartNumber !== undefined && this.selectedPartNumber !== '')
					? this.selectedPartNumber
					: newRow.cells[partIndex];
				if (!this.partNumber) {
					partNumber = newRow.cells[partIndex];
				}
				const mrpIndex: number = this.table.cellNames?.PART_MRP!;
				newRow.cells[mrpIndex] = this.inputMrp ;
				const availableQuantityIndex: number = this.table.cellNames?.AVAILABLE_QUANITY!;
				const reserveQuantityIndex: number = this.table.cellNames?.X_REZERVNAZAK!;
				const spDiscountIndex: number = this.table.cellNames?.SP_DISCOUNTED!;
				const unitIndex: number = this.table.cellNames?.CONVERTED_UNIT_OF_MEASUREMENT!;
				const quantityIndex: number = this.table.cellNames?.X_REZERVVLASTNI!;
				let quantity = newRow.cells[quantityIndex];
				const unitOfMeasure = newRow.cells[unitIndex];
				newRow.cells[unitIndex] = (this.selectedUnitText !== null && this.selectedUnitText !== undefined)
					? this.selectedUnitText
					: newRow.cells[unitIndex];
				const textIndex: any = this.table.cellNames?.TEXT;
				newRow.cells[textIndex] = (this.descriptionInput !== null && this.descriptionInput !== undefined)
					? this.descriptionInput
					: newRow.cells[textIndex];
				const baseUnitIndex: number = this.table.cellNames?.BASE_UNIT_OF_MEASUREMENT!;
				newRow.cells[baseUnitIndex] = (this.selectedBaseUnitIndex !== null && this.selectedBaseUnitIndex !== undefined)
					? this.selectedBaseUnitIndex
					: newRow.cells[baseUnitIndex];
				newRow.cells[textIndex] = newRow.cells[textIndex];
				const rrpUnitPriceIndex:number = this.table.cellNames?.RRP_UNIT_PRICE!;
				newRow.cells[rrpUnitPriceIndex] = (this.inputRrpUnitPrice !== null && this.inputRrpUnitPrice !== undefined)
					? this.inputRrpUnitPrice
					: newRow.cells[rrpUnitPriceIndex];
				newRow.cells[availableQuantityIndex] = (this.availableQuantity !== null && this.availableQuantity !== undefined)
					? this.availableQuantity
					: newRow.cells[availableQuantityIndex];
				newRow.cells[reserveQuantityIndex] = (this.reserveQuantity !== null && this.reserveQuantity !== undefined)
					? this.reserveQuantity
					: newRow.cells[reserveQuantityIndex];
				newRow.cells[spDiscountIndex] = (this.spDiscount !== null && this.spDiscount !== undefined)
					? this.spDiscount
					: newRow.cells[spDiscountIndex];
				const technicianIndex: number = this.table.cellNames!.TECHNICIAN;
				newRow.cells[technicianIndex] = (this.technicianId !== null && this.technicianId !== undefined)
					? this.technicianId
					: newRow.cells[technicianIndex];
				// const serviceJobIndex: number = this.table.cellNames!.SERVICE_JOB_ID;
				// newRow.cells[serviceJobIndex] = this.serviceJobId;
				if (!_.isNil(newRow.cells[partIndex]) && !_.isNil(wearHouse) && !_.isNil(quantity) && wearHouse !== '') {
					if (quantity === '') {
						quantity = DefualtQuantity;
					}
					const { data: isObsoletePartStock } = await apiProvider.getisObsoletePartStock(newRow.cells[partIndex], wearHouse, brand, quantity);
					this.showObsoleteErrorMsg(isObsoletePartStock, newRow, partIndex);
			}
				this.isPartBlock(newRow.cells[partIndex], brand, quantity);

				// If discount is empty then assign 0
				if (newRow.cells[discountIndex] === null || newRow.cells[discountIndex] === undefined || newRow.cells[discountIndex] === '') {
					newRow.cells[discountIndex] = 0;
				}
				// On first-time reservation part insertion with a selected service job, validate split-party discount limits.
				if (!(itemId > 0) && savedServiceJobId > 0) {
					const { data: insertionValidationMessage } = await apiProviderNd.validateServiceJobWhileReservationPartInsertion(
						savedServiceJobId,
						this.ZakazkaId!,
						+(newRow.cells[mrpIndex] ?? 0),
						this.loggedUser.DiscountLimitConfigData?.PartItemPer ?? 0,
						+(newRow.cells[rrpUnitPriceIndex] ?? 0),
						+(quantity ?? 0),
						+(wearHouse ?? 0),
						brand ?? '',
						newRow.cells[partIndex] ?? '',
					);
					if (insertionValidationMessage) {
						this.showErrorAlert({
							message: this.LocalizeChyboveHlasky(insertionValidationMessage),
							options: { type: 'error' },
							localizeMessage: false,
						});
						newRow.cells[serviceJobColIndex] = null;
						return false;
					}
				}
				const endTime = performance.now() - startTime;
				let seconds = parseFloat((endTime / 1000).toFixed(2));
				await apiProvider.logPerformance('OrderPrp', 'Reservation', ROW_SAVED, seconds);
				return true;
			}
			finally {
				this.endLoading();
			}
		},
		rowCancel(row: any) {
			if (!row?.row) {
				return;
			}
			const availableQuantityIndex: number = this.table.cellNames?.AVAILABLE_QUANITY!;
			const reserveQuantityIndex: number = this.table.cellNames?.X_REZERVNAZAK!;
			const spDiscountIndex: number = this.table.cellNames?.SP_DISCOUNTED!;
			const wareHouseIndex: number = this.table.cellNames?.X_SKLAD_OZN!;
			const brandIndex: number = this.table.cellNames?.VYROBEKND_OZN!;
			const partNumberIndex: number = this.table.cellNames?.ND_NR!;
			const partDescriptionIndex: number = this.table.cellNames?.TEXT!;
			const partQuantityIndex: number = this.table.cellNames?.X_REZERVVLASTNI!;
			const partMrpIndex: number = this.table.cellNames?.PART_MRP!;
			const unitIndex: number = this.table.cellNames?.CONVERTED_UNIT_OF_MEASUREMENT!;
			const partCategoryIndex:number = this.table.cellNames?.X_VYROBEKND_OZN!;
			const rrpUnitPriceIndex: number = this.table.cellNames?.RRP_UNIT_PRICE!;
			this.inputPartCategory = this.cancelPartCategory;
			row.row.cells[partCategoryIndex] = this.cancelPartCategory;

			this.inputWareHouse = this.cancelWareHouse;
			row.row.cells[wareHouseIndex] = this.cancelWareHouse;
			this.inputBrand = this.cancelBrand;
			row.row.cells[brandIndex] = this.cancelBrand;
			this.inputPartNumber = this.cancelPartNumber;
			row.row.cells[partNumberIndex] = this.cancelPartNumber;
			this.inputDescription = this.cancelDescription;
			row.row.cells[partDescriptionIndex] = this.cancelDescription;
			this.inputQuantity = this.cancelQuantity;
			row.row.cells[partQuantityIndex] = this.cancelQuantity;
			//this.inputMrp = this.cancelMrp;
			row.row.cells[partMrpIndex] = this.cancelMrp;
			this.inputUnit = this.cancelUnit;
			row.row.cells[unitIndex] = this.cancelUnit;
			this.inputRrpUnitPrice = this.cancelRrpUnitPrice;
			row.row.cells[rrpUnitPriceIndex] = this.cancelRrpUnitPrice;
			this.availableQuantity = this.cancelAvailableQuantity;
			row.row.cells[availableQuantityIndex] = this.cancelAvailableQuantity;
			this.reserveQuantity = this.cancelReserveQuantity;
			row.row.cells[reserveQuantityIndex] = this.cancelReserveQuantity;
			this.spDiscount = this.cancelSpDiscount;
			row.row.cells[spDiscountIndex] = this.cancelSpDiscount;
		},
		getCachedIndexes() {
			if (this._indexCache) {
				return this._indexCache;
			}

			this._indexCache = {
				wareHouseIndex: this.table.cellNames?.X_SKLAD_OZN!,
				technicianIdIndex: this.table.cellNames?.TECHNICIAN!,
				brandIndex: this.table.cellNames?.VYROBEKND_OZN!,
				partNumberIndex: this.table.cellNames?.ND_NR!,
				availableQuantityIndex: this.table.cellNames?.AVAILABLE_QUANITY!,
				reserveQuantityIndex: this.table.cellNames?.X_REZERVNAZAK!,
				spDiscountIndex: this.table.cellNames?.SP_DISCOUNTED!,
				unitIndex: this.table.cellNames?.CONVERTED_UNIT_OF_MEASUREMENT!,
				baseUnitIndex: this.table.cellNames?.BASE_UNIT_OF_MEASUREMENT!,
				partDescriptionIndex: this.table.cellNames?.TEXT!,
				partQuantityIndex: this.table.cellNames?.X_REZERVVLASTNI!,
				partMrpIndex: this.table.cellNames?.PART_MRP!,
				partCategoryIndex: this.table.cellNames?.X_VYROBEKND_OZN!,
				rrpUnitPriceIndex: this.table.cellNames?.RRP_UNIT_PRICE!,
				technicianIndex: this.table.cellNames!.TECHNICIAN,
				serviceJobIndex: this.table.cellNames!.SERVICE_JOB_ID,
				partIndex: this.table.cellNames?.ND_NR!,
			};

			return this._indexCache;
		},

		async performAsyncEditOperations(row: Row, indexes: any) {
			try {
				const brand = row.cells[indexes.brandIndex] || this.brand;
				const wearHouse = row.cells[indexes.wareHouseIndex] || this.wearHouse;
				const orderColId: number = this.table.cellNames!.ZAKAZKA_NR!;
				const orderId: any = this.getOrderDetails(row, orderColId);

				await this.loadPartsListIfNeeded(brand, wearHouse);

				const hasWarranty = await this.debouncedWarrantyCheck(row, orderId);
				this.isDiscountEditable = !hasWarranty;

				if (this.isDNPVisible()) {
					this.isDNPEditable = true;
					this.debouncedMrpFetch(this.partNumber, brand, orderId, wearHouse);
				}

			} catch (error) {
				this.logError(error as Error);
			}
		},

		async loadPartsListIfNeeded(brand: string, wearHouse: any) {
			try {
				if (!this.optimizePerf) {
					// Standalone reservation list: original behavior (no cache, no freeze).
					const shouldFetchParts =
						(this.props.partsListData === undefined || this.props.partsListData.length === 0) &&
						(this.wearHouse !== wearHouse || this.dropdownList.DefaultPartsList === undefined || this.dropdownList.DefaultPartsList.length === 0);

					const shouldUsePropsParts =
						this.filter.DefaultWarehouseId != null &&
						this.filter.DefaultWarehouseId!.toString() === wearHouse?.toString();

					if (shouldFetchParts) {
						const { data: result } = await apiProvider.getPartsList(brand, wearHouse);
						this.dropdownList.DefaultPartsList = result.DropDownList.partsList;
						this.dropdownList.Parts = this.dropdownList.DefaultPartsList.slice(0, 100);
					} else if (shouldUsePropsParts) {
						this.dropdownList.DefaultPartsList = this.props.partsListData;
						this.dropdownList.Parts = this.dropdownList.DefaultPartsList.slice(0, 100);
					}

					if (this.wearHouse !== wearHouse) {
						this.wearHouse = wearHouse;
					}
					return;
				}

				// Order screen: cached + frozen lists.
				const cacheKey = `${wearHouse}|${brand}`;
				const cached = this.partsListCache.get(cacheKey);
				if (cached) {
					this.dropdownList.DefaultPartsList = cached;
					this.dropdownList.Parts = cached.slice(0, 100);
					if (this.wearHouse !== wearHouse) {
						this.wearHouse = wearHouse;
					}
					return;
				}

				const shouldFetchParts =
					(this.props.partsListData === undefined || this.props.partsListData.length === 0) &&
					(this.wearHouse !== wearHouse || this.dropdownList.DefaultPartsList === undefined || this.dropdownList.DefaultPartsList.length === 0);

				const shouldUsePropsParts =
					this.filter.DefaultWarehouseId != null &&
					this.filter.DefaultWarehouseId!.toString() === wearHouse?.toString();

				if (shouldFetchParts) {
					const { data: result } = await apiProvider.getPartsList(brand, wearHouse);
					// frozen: Vue 2 skips reactivity conversion of thousands of items
					const list = Object.freeze(result.DropDownList.partsList) as any;
					this.partsListCache.set(cacheKey, list);
					this.dropdownList.DefaultPartsList = list;
					this.dropdownList.Parts = list.slice(0, 100);
				} else if (shouldUsePropsParts) {
					const list = Object.freeze(this.props.partsListData.slice()) as any;
					this.partsListCache.set(cacheKey, list);
					this.dropdownList.DefaultPartsList = list;
					this.dropdownList.Parts = list.slice(0, 100);
				}

				if (this.wearHouse !== wearHouse) {
					this.wearHouse = wearHouse;
				}
			} catch (error) {
				this.logError(error as Error);
			}
		},

		async onEditRow({ rowIndex, row }: { rowIndex: number, row: Row }) {
			this.startLoading();
			this.partsMenuReady = true; // prime dropdown DOM once per page session

			try {
				const indexes = this.getCachedIndexes();

				const wareHouseValue = row.cells[indexes.wareHouseIndex];
				const technicianIdValue = row.cells[indexes.technicianIdIndex];
				const partCategoryValue = row.cells[indexes.partCategoryIndex];
				const brandValue = row.cells[indexes.brandIndex];
				const partNumberValue = row.cells[indexes.partNumberIndex];
				const partDescriptionValue = row.cells[indexes.partDescriptionIndex];
				const partMrpValue = row.cells[indexes.partMrpIndex];
				this.cancelMrp = partMrpValue;
				this.inputMrp = partMrpValue;
				const partQuantityValue = row.cells[indexes.partQuantityIndex];
				const unitValue = row.cells[indexes.unitIndex];
				const baseUnitValue = row.cells[indexes.baseUnitIndex];
				const rrpUnitPriceValue = row.cells[indexes.rrpUnitPriceIndex];
				const availableQuantityValue = row.cells[indexes.availableQuantityIndex];
				const reserveQuantityValue = row.cells[indexes.reserveQuantityIndex];
				const spDiscountValue = row.cells[indexes.spDiscountIndex];
				const serviceJobIdValue = row.cells[indexes.serviceJobIndex];
				const technicianIndexValue = row.cells[indexes.technicianIndex];
				const discountAmountColId: number = this.table.cellNames!.DISCOUNT_VAL;
				const discountPercentColId: number = this.table.cellNames!.DISCOUNT_PERCENT;
				this.originalDiscountAmount = row.cells[discountAmountColId];
				this.originalDiscountPercent = row.cells[discountPercentColId];
				this.discountAmountReverted = false;

				const editRowState = {
					inputWareHouse: wareHouseValue,
					inputTechnicianId: technicianIdValue,
					inputPartCategory: partCategoryValue,
					inputBrand: brandValue,
					inputPartNumber: partNumberValue,
					inputDescription: partDescriptionValue,
					inputMrp: partMrpValue,
					inputQuantity: partQuantityValue,
					inputUnit: unitValue,
					inputRrpUnitPrice: rrpUnitPriceValue,

					descriptionInput: partDescriptionValue,
					selectedUnitText: unitValue,
					selectedBaseUnitIndex: baseUnitValue,

					cancelWareHouse: wareHouseValue,
					canceltechnicianId: technicianIdValue,
					cancelPartCategory: partCategoryValue,
					cancelBrand: brandValue,
					cancelPartNumber: partNumberValue,
					cancelDescription: partDescriptionValue,
					cancelMrp: partMrpValue,
					cancelQuantity: partQuantityValue,
					cancelUnit: unitValue,
					cancelRrpUnitPrice: rrpUnitPriceValue,

					availableQuantity: availableQuantityValue,
					cancelAvailableQuantity: availableQuantityValue,
					reserveQuantity: reserveQuantityValue,
					cancelReserveQuantity: reserveQuantityValue,
					spDiscount: spDiscountValue,
					cancelSpDiscount: spDiscountValue,

					serviceJobId: serviceJobIdValue,
					technicianId: technicianIndexValue,
					partNumber: partNumberValue,
					selectedPartNumber: partNumberValue,
					brand: partCategoryValue,
					partMrp: partMrpValue,
					isDiscountEditable: true,
					isDNPEditable: this.isDNPVisible(),
				};

				if (!this.isFromReservation) {
						requestAnimationFrame(() => {
						Object.assign(this, editRowState);
						// One more frame so the row commits to the DOM before background checks start.
						requestAnimationFrame(() => {
							this.performAsyncEditOperations(row, indexes);
						});
					});
				} else {
					Object.assign(this, editRowState);

					this.$nextTick(() => {
						this.performAsyncEditOperations(row, indexes);
					});
				}

			} catch (error) {
				this.logError(error as Error);
			} finally {
				this.endLoading();
			}
		},
		getCellDetails(row: Row, columnId: number) {
			return row.cells[columnId];
		},
		getOrderDetails(row: Row, columnId: number) {
			if (!this.isFromReservation) {
				// orderResult = this.dropdownList.Orders.find((item: any) => item.Value === this.ZakazkaId)!;
				return this.filter.OrderNo;
			}
			const orderResult: DropdownItem = this.dropdownList.Orders.find((item: any) => item.Value === row.cells[columnId])!;
			return orderResult?.Text ?? row.cells[columnId];
		},
		getTechnicianDetails(row: Row, columnId: number) {
			let result = null;
			if (this.dropdownList.TechiciansList !== undefined) {
				result = this.dropdownList.TechiciansList.find(
					(item: any) => item.Value === parseInt(row?.cells[columnId]),
				);
			}
			return result?.Text ?? row.cells[columnId];
		},
		getServiceJobDetails(row: Row, columnId: number) {
			let result = null;
			if (this.dropdownList.ServiceJobsList) {
				result = this.dropdownList.ServiceJobsList.find(
					(item: any) => item.Value === parseInt(row?.cells[columnId]),
				);
			}
			return result?.Text ?? row.cells[columnId];
		},
		getServiceJobNameDetails(row: Row, columnId: number) {
			
			const columns:number = this.table.cellNames?.SERVICE_JOB_NAME!;
			return row?.cells[columns];
		},
		onTechnicianChange(value :number, columnId: number, row : Row, updateCol : any) {
			this.technicianId = value;
			updateCol(value, columnId);
			
		},

		async onServiceJobChange(value: string, columnId: number, row: Row, updateCol: any) {
			if (value !== null) {
				const newServiceJobId = parseInt(value);
				this.$store.commit(`${this.storeUri}/${START_LOADING}`);
				const invoiceStatus = await this.isAnyServiceJobSplitPartyInvoiced(newServiceJobId, row);
				if (invoiceStatus.IsServiceJobPartyInvoiced) {
					showAlert({
						message: this.LocalizeChyboveHlasky('Invoice_Generated_For_SJ_Msg'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'info',
						},
					});
					const previousServiceJobId = parseInt(row.cells[columnId]);
					updateCol(previousServiceJobId, columnId);
					row.cells[columnId] = previousServiceJobId;
				} else if (invoiceStatus.IsPrimaryCustomerInvoiced) {
					showAlert({
						message: this.LocalizeChyboveHlasky('Primary_Customer_Invoiced_For_SJ_Msg'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'info',
						},
					});
					const previousServiceJobId = parseInt(row.cells[columnId]);
					updateCol(previousServiceJobId, columnId);
					row.cells[columnId] = previousServiceJobId;
				} else if (invoiceStatus.IsServiceJobViolatingDiscountLimit) {
					showAlert({
						message: this.LocalizeChyboveHlasky('Service_Job_Violates_Discount_Limit_Msg'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'info',
						},
					});
					const previousServiceJobId = parseInt(row.cells[columnId]);
					updateCol(previousServiceJobId, columnId);
					row.cells[columnId] = previousServiceJobId;
				} else if (this.isServiceJobSplitBillingAvailableForOrderType()) {
					updateCol(newServiceJobId, columnId);
					row.cells[columnId] = value;
					if (await this.isWarrantyOrGoodwillExistInServiceJobSplit(newServiceJobId)) {
						showAlert({
							message: this.LocalizeChyboveHlasky('Zero_Discount_Warning_Msg'),
							title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
							options: {
								type: 'info',
							},
						});
						const discountColId = this.table.cellNames?.DISCOUNT_PERCENT;
						if (discountColId !== undefined) {
							row.cells[discountColId] = 0;
						}
					}
				} else {
					showAlert({
						message: this.LocalizeChyboveHlasky('SJ_Split_Warning_Msg'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'info',
						},
					});
				}
				if (!invoiceStatus.IsAnyDiscountPercentAndAmount){
					const DiscountPercentCol = this.table.cellNames?.DISCOUNT_PERCENT ?? 0;
					const DiscountAmountCol = this.table.cellNames?.DISCOUNT_VAL ?? 0;
					 updateCol(0, DiscountPercentCol);
					 updateCol(0, DiscountAmountCol);
					row.cells[DiscountPercentCol] = 0;
					row.cells[DiscountAmountCol] = 0;
				}
				this.$store.commit(`${this.storeUri}/${END_LOADING}`);
			} else {
				updateCol(null, columnId);
				row.cells[columnId] = null;
			}
		},

		async isSagaSplitPartyExistInServiceJob(serviceJobId:number) {
			const { data: isSagaSplitPartyExists } = await orderApiProvider.isSagaSplitsExistInServiceJobSplit(serviceJobId, this.ZakazkaId!);
			return isSagaSplitPartyExists;
		},

		async isAnyServiceJobSplitPartyInvoiced(serviceJobId:number, row: Row) {
			const partNumberColId: number = this.table!.cellNames!.ZAZNAM_ID;
			const itemId = row.cells[partNumberColId];
			const discountLimitPercent = this.loggedUser.DiscountLimitConfigData?.PartItemPer ?? 0;
			const { data: isInvoiced } = await apiProvider.fetchInvoiceStatusOfServiceJobParty(this.ZakazkaId!, serviceJobId, itemId, PARTS, discountLimitPercent);
			return isInvoiced;
		},

		async isWarrantyOrGoodwillExistInServiceJobSplit(serviceJobId: number) {
			const response = await apiProviderNd.isWarrantyOrGoodwillExistInServiceJobSplit(this.ZakazkaId!, serviceJobId);
			return response?.data;
		},

		isServiceJobSplitBillingAvailableForOrderType(): boolean {
			return (this.ZakazkaDruh === ZAKAZKA_DRUH.DILENSKA);
		},
		getWorkshopDetails(row: Row, columnId: number) {
			const workshopResult: DropdownItem = this.dropdownList.SkladOzn.find((item: any) => item.Value === Number(row.cells[columnId]))!;
			return workshopResult?.Text ?? row.cells[columnId];
		},
		getPartType(row: Row, columnId: number) {
			const orderResult: DropdownItem = this.dropdownList.VyrobekndOzn.find((item: any) => item.Value === row.cells[columnId])!;
			return orderResult?.Text ?? row.cells[columnId];
		},
		getMrp(row: Row, columnId: number) {
			try {
				if (this.optimizePerf) {
					const key = String(row.cells[columnId]);
					const map = this.isDNPVisible() ? this.dnpTextByValue : this.mrpTextByValue;
					const cached = map.get(key);
					if (cached !== undefined) {
						return cached;
					}
					// Map missed (GetCombinedMrpDnp didn't cover this code) — fall back to the order-scoped
					// list like the standalone screen does, and refresh the Map once it resolves.
					if (this.isDNPVisible()) {
						if (this.ZakazkaId !== null && this.dropdownList.AllDnp.length === 0 && !this.allDnpLoading) {
							this.allDnpLoading = true;
							apiProvider.getPriceForReserveParts(this.ZakazkaId!).then(({ data }) => {
								this.dropdownList.AllDnp = data;
								this.dnpTextByValue = new Map(data.map((item: any) => [String(item.Value), item.Text]));
							}).catch((error: Error) => {
								this.logError(error);
							}).finally(() => {
								this.allDnpLoading = false;
							});
						}
						const dnpResult: DropdownItem = this.dropdownList.AllDnp.find((item: any) => String(item.Value) === key)!;
						return dnpResult?.Text;
					}
					if (this.ZakazkaId !== null && this.dropdownList.AllMrp.length === 0 && !this.allMrpLoading) {
						this.allMrpLoading = true;
						apiProvider.getPriceForReserveParts(this.ZakazkaId!).then(({ data }) => {
							this.dropdownList.AllMrp = data;
							this.mrpTextByValue = new Map(data.map((item: any) => [String(item.Value), item.Text]));
						}).catch((error: Error) => {
							this.logError(error);
						}).finally(() => {
							this.allMrpLoading = false;
						});
					}
					const mrpResultOpt: DropdownItem = this.dropdownList.AllMrp.find((item: any) => String(item.Value) === key)!;
					return mrpResultOpt?.Text;
				}
				// Standalone reservation list: original implementation (unchanged).
				if (this.isDNPVisible()) {
					if (this.ZakazkaId !== null && this.dropdownList.AllDnp.length === 0 && !this.allDnpLoading) {
						this.allDnpLoading = true;
						apiProvider.getPriceForReserveParts(this.ZakazkaId!).then(({ data }) => {
							this.dropdownList.AllDnp = data;
						}).catch((error: Error) => {
							this.logError(error);
						}).finally(() => {
							this.allDnpLoading = false;
						});
					}
					const mrpResult: DropdownItem = this.dropdownList.AllDnp.find((item: any) => String(item.Value) === String(row.cells[columnId]))!;
					return mrpResult?.Text;
				}
				if (this.ZakazkaId !== null && this.dropdownList.AllMrp.length === 0 && !this.allMrpLoading) {
					this.allMrpLoading = true;
					apiProvider.getPriceForReserveParts(this.ZakazkaId!).then(({ data }) => {
						this.dropdownList.AllMrp = data;
					}).catch((error: Error) => {
						this.logError(error);
					}).finally(() => {
						this.allMrpLoading = false;
					});
				}
				const mrpResult: DropdownItem = this.dropdownList.AllMrp.find((item: any) => String(item.Value) === String(row.cells[columnId]))!;
				return mrpResult?.Text;
			} catch (error) {
				this.logError(error as Error);
			}
		},
		async handleOnCategoryChange(val: string, row: Row) {
			this.startLoading();
			try {
				const partNumberIndex:number = this.table.cellNames?.ND_NR!;
				const partDescriptionIndex:number = this.table.cellNames?.TEXT!;
				const partQuantityIndex:number = this.table.cellNames?.X_REZERVVLASTNI!;
				row.cells[partNumberIndex] = '';
				row.cells[partDescriptionIndex] = '';
				row.cells[partQuantityIndex] = '';
				row.cells[partQuantityIndex] = null;
				this.dropdownList.Mrp = [];
				// this.dropdownList.Parts = [];
				this.brand = val;
				this.selectedBrand = val;

				const wearHouseIndex: number = this.table.cellNames?.X_SKLAD_OZN!;
				let wearHouse = row.cells[wearHouseIndex];
				if (!wearHouse) {
					wearHouse = this.wearHouse;
				}

				const orderColId: number = this.table.cellNames!.ZAKAZKA_NR!;
				const orderId: any = this.getOrderDetails(row, orderColId);
				if (this.optimizePerf) {
					// Order screen: cached + frozen lists.
					const cacheKey = `${wearHouse}|${val}`;
					const cached = this.partsListCache.get(cacheKey);
					if (cached) {
						this.dropdownList.DefaultPartsList = cached;
						this.dropdownList.Parts = cached.slice(0, 100);
					} else if (this.dropdownList.DefaultPartsList === undefined || this.dropdownList.DefaultPartsList.length === 0) {
						const { data: result } = await apiProvider.getPartsList(val, wearHouse);
						const list = Object.freeze(result.DropDownList.partsList) as any;
						this.partsListCache.set(cacheKey, list);
						this.dropdownList.DefaultPartsList = list;
						this.dropdownList.Parts = list.slice(0, 100);
					}
					return;
				}
					if (this.dropdownList.DefaultPartsList === undefined || this.dropdownList.DefaultPartsList.length === 0) {
					const { data: result } = await apiProvider.getPartsList(val, wearHouse);
					this.dropdownList.DefaultPartsList = result.DropDownList.partsList;
					this.dropdownList.Parts = this.dropdownList.DefaultPartsList.slice(0, 100);
				}
				this.endLoading();
				return;
			} finally {
				this.endLoading();
			}
		},
		async handleOnWearhouseChange(val: string, row: Row) {
			this.startLoading();
			try {
				if (val !== '') {
					const partNumberIndex:number = this.table.cellNames?.ND_NR!;
					const partDescriptionIndex:number = this.table.cellNames?.TEXT!;
					const partQuantityIndex:number = this.table.cellNames?.X_REZERVVLASTNI!;
					const partCategoryIndex:number = this.table.cellNames?.X_VYROBEKND_OZN!;
					const partCategory:string = row.cells[partCategoryIndex];
					this.selectedPartNumber = '';
					row.cells[partCategoryIndex] = '';
					row.cells[partDescriptionIndex] = '';
					row.cells[partQuantityIndex] = '';
					this.dropdownList.Mrp = [];
					if (this.optimizePerf) {
						// Order screen: cached + frozen lists.
						const cacheKey = `${val}|`;
						const cached = this.partsListCache.get(cacheKey);
						if (this.filter.DefaultWarehouseId!.toString() == val && this.props.partsListData.length > 0) {
							const list = Object.freeze(this.props.partsListData.slice()) as any;
							this.partsListCache.set(cacheKey, list);
							this.dropdownList.DefaultPartsList = list;
							this.dropdownList.Parts = list.slice(0, 100);
						} else if (cached) {
							this.dropdownList.DefaultPartsList = cached;
							this.dropdownList.Parts = cached.slice(0, 100);
						} else {
							const { data: result } = await apiProvider.getPartsList('', val);
							const list = Object.freeze(result.DropDownList.partsList) as any;
							this.partsListCache.set(cacheKey, list);
							this.dropdownList.DefaultPartsList = list;
							this.dropdownList.Parts = list.slice(0, 100);
							if (this.filter.DefaultWarehouseId!.toString() == val) {
								this.props.partsListData = result.DropDownList.partsList;
							}
						}
					} else {
						if (this.filter.DefaultWarehouseId!.toString() == val && this.props.partsListData.length > 0) {
							this.dropdownList.DefaultPartsList = this.props.partsListData;
							this.dropdownList.Parts = this.dropdownList.DefaultPartsList.slice(0, 100);
						} else {
							const { data: result } = await apiProvider.getPartsList('', val);
							this.dropdownList.DefaultPartsList = result.DropDownList.partsList;
							this.dropdownList.Parts = this.dropdownList.DefaultPartsList.slice(0, 100);
							if (this.filter.DefaultWarehouseId!.toString() == val) {
								this.props.partsListData = result.DropDownList.partsList;
							}
						}
					}
				}
				this.isDNPEditable = false;
				if (this.isDNPVisible()) {
					this.isDNPEditable = true;
				}
			} finally {
				this.endLoading();
			}
		},
		handleOrderChange(val: string, row: Row) {
			this.orderId = parseInt(val);
		},
		onEanInput(event: any, row: Row, columnId: number) {
			this.eanInput = event;
			row.cells[columnId] = event;
		},
		async onQuantityInput(event: any, row: Row, columnId: number) {
			this.quantityInput = event;
			row.cells[columnId] = event;
		},
		booleanIcon(row: Row, columnId: number): string {
			return row.cells[columnId] ? 'el-icon-check' : 'el-icon-close';
		},
		async GetConversionUnitsForPart(partNumber: string, brand: string, wearHouse: number) {
			const { data } = await apiProvider.getConversionUnits(partNumber, wearHouse, brand);
			this.expandedUnit = data.ExpandedUnit;
			return data.UnitOfMeasure;
		},
		async deleteRow(rowIndex: number, row: Row) {
			const idIndex = this.table!.cellNames!.ZAZNAM_ID;
			const idToDelete = row.cells[idIndex];
			let confirmDelete = true;
			confirmDelete = await this.showConfirm({
				message: this.LocalizeChyboveHlasky('SURE_TO_DELETE'),
				title: this.LocalizeChyboveHlasky('SURE_TO_DELETE_CONFIRM'),
				options: {
					confirmButtonText: this.Localize('Ano'),
					cancelButtonText: this.Localize('Ne'),
				},
			});
			if (confirmDelete) {
				this.startLoading();
				await apiProvider.deleteReservePartFromSplitbilling(this.ZakazkaId, idToDelete);
				await apiProvider.deleteEntity(idToDelete);
				this.endLoading();
			}
			await this.tableData();
			(this.$refs.table as any).refreshLayout();
		},
		async isPartBlock(partNumber: string, brand: string, quantity: number) {
			if (partNumber && brand && quantity) {
				const { data: isPartBlock } = await apiProviderParts.isPartBlock(partNumber, brand, quantity);
				if (isPartBlock) {
					showAlert({
						message: this.LocalizeChyboveHlasky('PartQuantityIsBlocked'),
						title: this.LocalizeChyboveHlasky('DMS3_ErrorTitle'),
						options: {
							type: 'error',
						},
					});
				}
			}
		},
		isDecimal(num: number) {
			return (num % 1);
		},
		async handleSaveClick() {
			if (this.isSaving) {
				return;
			}
			this.isSaving = true;
			let count = 0;

			const partsData = convertToObjects(this.table).map((part, idx) => {
				if (part.ZaznamId < 0) {
					part.ZaznamId = null;
				}
				if (part.IsAdditional === null) {
					part.IsAdditional = false;
				}
				if (!this.isFromReservation && part.ZakazkaId === null) {
					part.ZakazkaId = this.ZakazkaId;
				} else {
					part.ZakazkaId = this.orderId;
				}

				if (!part.XRezervvlastni || !part.NdNr || !part.PartMrp || !part.Text || part.XRezervvlastni <= 0 || part.XSkladOzn === null || part.XSkladOzn === '') {
					count++;
				}
				return ({ ...part });
			});

			if (count > 0) {
				this.showErrorAlert({ message: this.LocalizeChyboveHlasky('PLEASE_ENTER_REQUIRED_VALUES_FOR_PARTS') });
				this.isSaving = false;
				return;
			}

			if (!this.isFromReservation) {
				this.filter.ZakazkaId = this.ZakazkaId;
			}
			this.startLoading();
			try {
				await apiProvider.partReservation(partsData, !this.isFromReservation, this.filter);
				this.endLoading();
				await this.tableData();
				(this.$refs.table as any).refreshLayout();
			} catch (err) {
				this.logError(err as Error);
			} finally {
				this.isSaving = false;
			}
		},
		async isWarrantyOrGoodwillSplitExists(row:Row, orderId: number) {
			const rezPartNumberColId: number = this.table.cellNames!.ZAZNAM_ID;
			const itemId = row.cells[rezPartNumberColId];
			const response = await apiProvider.isWarrantyExistInSplit(itemId, orderId, PARTS);
			return response?.data;
		},
		isDNPVisible() : boolean {
			if (this.props?.IsDNPVisible !== null) {
				return this.props?.IsDNPVisible;
			}

			return this.$route?.query?.IsDNPVisible?.toString().toLowerCase() === 'true';
		},
		canAddPart() : boolean {
			if (this.props?.CanAddPartOrLabour !== null) {
				return this.props?.CanAddPartOrLabour;
			}

			return this.$route?.query?.CanAddPartOrLabour?.toString().toLowerCase() === 'true';
		},
		async CheckDnpValue() {
			return this.isDNPVisible();
		},

		async onWorkShopChange(workshopId: any) {
			if (workshopId !== undefined || workshopId !== null) {
				this.filter.SkladOzn = null;
				const { data } = await apiProvider.GetWarehouse(workshopId);
				this.dropdownList.WorkshopList = data;
			}
		},
		async showObsoleteErrorMsg(isObsoletePartStock: any, newRow: Row, ndNrIndex: number) {
			if (isObsoletePartStock.IsObsoletePart) {
				const replacement = [{
					key: '<SUPERSEDED_PART_NUMBER>',
					value: isObsoletePartStock.SupersededPartNumber,
				},
				{
					key: '<SUPERSEDED_DATE>',
					value: isObsoletePartStock.SupersededDate,
				}];
				if (isObsoletePartStock.IsQuantityAvailable && !_.isNil(isObsoletePartStock.SupersededPartNumber)) {
					const confirmChangePart = await this.showConfirm({
						message: this.LocalizeAndReplaceMultiple(
							this.LocalizeChyboveHlasky('msgPartObsoleteSuperseded'),
							replacement,
						),
						title: this.LocalizeChyboveHlasky('questionTitle'),
						options: {
							confirmButtonText: this.Localize('Ano'),
							cancelButtonText: this.Localize('Ne'),
							closeOnPressEscape: false,
							closeOnClickModal: false,
						},
					});
					if (confirmChangePart) {
						this.startLoading();
						newRow.cells[ndNrIndex] = isObsoletePartStock.SupersededPartNumber;
						this.selectedPartNumber = isObsoletePartStock.SupersededPartNumber;
						this.handleOnPartChange(isObsoletePartStock.SupersededPartNumber, newRow, ndNrIndex);
						this.endLoading();
					}
				} else if (!isObsoletePartStock.IsQuantityAvailable && !_.isNil(isObsoletePartStock.SupersededPartNumber)) {
					const confirmChangePart = await this.showConfirm({
						message: this.LocalizeAndReplaceMultiple(
							this.LocalizeChyboveHlasky('msgPartObsoleteSupersededQuantity'),
							replacement,
						),
						title: this.LocalizeChyboveHlasky('questionTitle'),
						options: {
							confirmButtonText: this.Localize('Ano'),
							cancelButtonText: this.Localize('Ne'),
							closeOnPressEscape: false,
							closeOnClickModal: false,
						},
					});
					if (confirmChangePart) {
						this.startLoading();
						newRow.cells[ndNrIndex] = isObsoletePartStock.SupersededPartNumber;
						this.selectedPartNumber = isObsoletePartStock.SupersededPartNumber;
						this.handleOnPartChange(isObsoletePartStock.SupersededPartNumber, newRow, ndNrIndex);
						this.endLoading();
					} else {
						newRow.cells[ndNrIndex] = '';
						this.selectedPartNumber = '';
					}
                }
           } else if (!isObsoletePartStock.IsQuantityAvailable && !_.isNil(isObsoletePartStock.SupersededPartNumber)) {
					this.selectedPartNumber = isObsoletePartStock.SupersededPartNumber;
				}
			},

		validateRowLevelDiscount(value: any, updateCol: any, row: Row): boolean {
			const discountPercentColId = this.table.cellNames!.DISCOUNT_PERCENT;
			const discountAmountColId = this.table.cellNames!.DISCOUNT_VAL;
			const priceBeforeDiscountColId = this.table.cellNames!.PC_CEL_SL_PRED;
			const discountPercent = value;
			const configuredDiscountLimit = this.loggedUser.DiscountLimitConfigData?.PartItemPer ?? 0;
			if (value === null || value === undefined || value === '') {
				return true;
			}
			const percentValue = +(_.defaultTo(discountPercent, 0));
			const totalDiscountPercent = +(_.defaultTo(discountPercent, 0));
			if (percentValue < 0 || percentValue > 100) {
				this.showErrorAlert({ message: this.LocalizeChyboveHlasky('SB_DISCOUNT_PERCENT_INVALID') });
				updateCol(null, discountPercentColId);
				row.cells[discountPercentColId] = null;
				return false;
			}

			if (configuredDiscountLimit !== undefined && configuredDiscountLimit !== null && totalDiscountPercent > configuredDiscountLimit) {
				this.showErrorAlert({ message: this.LocalizeChyboveHlasky('SB_DISCOUNT_AMOUNT_EXCEEDS_LIMIT') });
				updateCol(null, discountPercentColId);
				row.cells[discountPercentColId] = null;
				return false;
			}
			updateCol(percentValue, discountPercentColId);
			if (percentValue > 0) {
				updateCol(null, discountAmountColId);
			}
			row.cells[discountPercentColId] = percentValue;
			return true;
		},

		onRowDiscountAmountLeave(value: any, row: Row, columnId: number, updateCol: any): Boolean {
			const discountPercentColId = this.table.cellNames!.DISCOUNT_PERCENT;
			const discountAmountColId = this.table.cellNames!.DISCOUNT_VAL;
			const unitPriceColId = this.table.cellNames!.RRP_UNIT_PRICE;
			const quantityColId = this.table.cellNames!.X_REZERVVLASTNI;
			const discountAmount = value;
			if (discountAmount === undefined) {
				return true;
			}
			if (discountAmount === null || discountAmount === undefined || discountAmount === '') {
				return false;
			}

			const amountValue = +discountAmount;
			if (Number.isNaN(amountValue) || amountValue < 0) {
				this.showErrorAlert({ message: this.LocalizeChyboveHlasky('SB_DISCOUNT_AMOUNT_INVALID') });
				updateCol(null, discountAmountColId);
				return false;
			}

			const itemIdColId = this.table.cellNames!.ZAZNAM_ID;
			const itemId: number = +(row.cells[itemIdColId] ?? 0);
			if (itemId <= 0) {
				const originalPrice = +(row.cells[unitPriceColId] ?? 0) * +(row.cells[quantityColId] ?? 1);
				if (amountValue > originalPrice) {
					this.showErrorAlert({ message: this.LocalizeChyboveHlasky('DiscountCannotBeLarger') });
					updateCol(null, discountAmountColId);
					return false;
				}
			}

			updateCol(amountValue, discountAmountColId);
				if (amountValue > 0) {
				updateCol(null, discountPercentColId);
			}
			return true;
		},
		
		},

	},

);
